import RecommendedProductsModal from "./RecommendedProductsModal";
export default RecommendedProductsModal;
